export default "__VITE_ASSET__4Ast9Hwu__"